import { CheckIcon, SortIcon } from '../../../components/ui/icons';
import { useState } from 'react';
import {
  Button,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import { CollectionSortOption } from '../types';
import { dialogPaperSurface } from '../../../surfaceStyles';

export function CollectionSortControl<T extends string>({
  noun,
  value,
  options,
  compact,
  onChange,
}: {
  noun: string;
  value: T;
  options: CollectionSortOption<T>[];
  compact: boolean;
  onChange: (value: T) => void;
}) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const selected =
    options.find((option) => option.value === value) || options[0];

  return (
    <>
      {compact ? (
        <IconButton
          size="small"
          aria-label={`Sort ${noun}s: ${selected.label}`}
          aria-controls={anchor ? `${noun}-sort-menu` : undefined}
          aria-haspopup="menu"
          aria-expanded={anchor ? 'true' : undefined}
          onClick={(event) => setAnchor(event.currentTarget)}
          sx={{ flexShrink: 0, color: 'text.secondary' }}
        >
          <SortIcon />
        </IconButton>
      ) : (
        <Button
          size="small"
          startIcon={<SortIcon />}
          aria-label={`Sort ${noun}s: ${selected.label}`}
          aria-controls={anchor ? `${noun}-sort-menu` : undefined}
          aria-haspopup="menu"
          aria-expanded={anchor ? 'true' : undefined}
          onClick={(event) => setAnchor(event.currentTarget)}
          sx={{ flexShrink: 0, color: 'text.secondary' }}
        >
          {`Sort: ${selected.label}`}
        </Button>
      )}
      <Menu
        id={`${noun}-sort-menu`}
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        slotProps={{
          paper: { sx: dialogPaperSurface },
          backdrop: { invisible: false },
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === value}
            onClick={() => {
              onChange(option.value);
              setAnchor(null);
            }}
          >
            <ListItemIcon>
              {option.value === value ? <CheckIcon fontSize="small" /> : null}
            </ListItemIcon>
            <ListItemText>{option.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
